import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: François Risoud
 * id 0C1B9015-C0F4-4710-87D2-BA7B710943F2
 * name map-marker-up
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/map-marker-up.svg
 * tags
 * - Navigation 
 * - Geographic Information System 
 */
export const MapMarkerUpIcon = createSvgIcon(<><path d="M12 2A7 7 0 0 0 5 9C5 14.25 12 22 12 22S19 14.25 19 9A7 7 0 0 0 12 2M16.5 9H14V14H10V9H7.5L12 4.5Z" /></>, 'MapMarkerUpIcon');
export default MapMarkerUpIcon